export const colors = {
  brandPrimary: '#1c2442',
  brandPrimaryLight: '#2e4a78',
  brandSecondary: '#3fa0ff',
  brandAccent: '#a4cbe6',
  brandLink: '#3845ab',
  brandBeige: '#cbccc8',
  brandCream: '#f4f5f0',
  neutralWhite: '#ffffff',
  neutralBlack: '#000000',
  neutralLightGray: '#f9f9fb',
  neutralGray: '#e4e4e4',
  neutralMediumGray: '#707070',
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6',

  badgeSuccessText: '#047857',
  badgeDangerText: '#b91c1c',
  badgeWarningText: '#92400e',
  badgeInfoText: '#1d4ed8',

  alertErrorBg: '#fef2f2',
  alertErrorBorder: '#fecaca',
  alertWarningBg: '#fff8e1',
  alertWarningBorder: '#ffe082',
  alertSuccessBg: '#f0fdf4',
  alertSuccessBorder: '#bbf7d0',

  solidSuccess: '#43c67c',
  solidDanger: '#e01234',
  solidWarning: '#ffbc58',
  successBgSubtle: '#d1fae5',
  inputBg: '#e5e6e2',
  formBorder: '#d5cbc8',
  borderLight: '#eee',
  accentBrown: '#755449',
  onboardingBrown: '#7b5b4f',
  accentBrownFocus: 'rgba(117, 84, 73, 0.18)',
  accentBrownStrongHover: 'rgba(117, 84, 73, 0.5)',
  accentBrownDeep: '#372724',
  personaSuper: '#775c51',
  persona: '#3B82F6',
  personaNon: '#6B7280',
  personaText: '#ffffff',
  classificationLeadBg: '#e6f4ed',
  classificationLeadText: '#347659',
  leadTemperatureWarm: '#e9a56c',
  leadTemperatureWarmText: '#ffffff',
  neutralIconGray: '#e3e3e3',
  surfaceMuted: '#e9e4e3',
  surfaceMutedSoft: '#f3efee',
  surfaceMutedHover: '#ece6e4',
  surfaceCardMuted: '#ecede8',
  surfaceCardSubtle: '#ececea',
  textSubtleStrong: '#6d5f5c',
  borderInfoSoft: '#bfd6ec',
  bgInfoSoft: '#bddaf3',
  borderSoftMuted: '#c2c2bc',
  borderInfoSoftTranslucent: 'rgba(191, 214, 236, 0.42)',
  accentPurple: '#be83f6',
  brandPrimaryFaint: 'rgba(28, 36, 66, 0.04)',
  brandPrimarySoft: 'rgba(28, 36, 66, 0.1)',
  brandSecondarySoft: 'rgba(63, 160, 255, 0.1)',
  shadowBrandStrong: 'rgba(28, 36, 66, 0.28)',
  shadowBrandDrag: 'rgba(28, 36, 66, 0.26)',
  borderBrandSubtle: 'rgba(28, 36, 66, 0.14)',
  bgDropzoneActive: 'rgba(242, 237, 229, 0.72)',
  whiteOverlay96: 'rgba(255, 255, 255, 0.96)',
  whiteOverlay88: 'rgba(255, 255, 255, 0.88)',
  whiteOverlay14: 'rgba(255, 255, 255, 0.14)',
  popoverBorder: 'rgba(15, 20, 31, 0.1)',
  popoverShadowStrong: 'rgba(15, 20, 31, 0.14)',
  popoverShadowSoft: 'rgba(15, 20, 31, 0.08)',
  popoverArrowBorder: 'rgba(15, 20, 31, 0.12)',
  popoverDivider: 'rgba(15, 20, 31, 0.06)',
  thumbnailOverlayStrong: 'rgba(15, 20, 31, 0.88)',
  sourceExternalBg: 'rgba(139, 90, 43, 0.05)',
  sourceMissingBg: 'rgba(230, 160, 50, 0.06)',
  successBadgeBg: 'rgba(34, 197, 94, 0.12)',
  successBadgeText: '#16a34a',
  neutralBadgeBg: 'rgba(156, 163, 175, 0.18)',
  errorBgFaint: 'rgba(220, 38, 38, 0.06)',
  formBorderSoft: 'rgba(213, 203, 200, 0.5)',
  surfaceGroupBadge: '#f2ece8',
  tagFallback: '#888',
  exerciseThumbnailFallbackBg: '#E6DED8',
  exerciseThumbnailFallbackText: '#6A4A3C',
  exerciseUploadErrorGradientStart: '#C45A3D',
  exerciseUploadErrorGradientEnd: '#5E2418',

  sidebarBg: 'rgba(215, 215, 213, 0.5)',
  sidebarBorder: 'rgba(117, 84, 73, 0.15)',
  sidebarDivider: 'rgba(117, 84, 73, 0.5)',
  sidebarIcon: '#755449',
  sidebarActiveBg: '#d7d7d5',
  sidebarArrow: '#755449',
  sidebarHover: 'rgba(215, 215, 213, 0.3)',
  sidebarAvatarBg: '#999',

  profileHeaderBg: '#e5e6e2',
  profileSectionLabel: '#755449',
  profileTabIndicator: '#755449',
};
